export const PAGE_SIZE = 10;

export const DEFAULT_SORTING_COLUMN = { sortingColumn: "timestamp" };

export const DEFAULT_PREFERENCES = {
  pageSize: PAGE_SIZE,
  wrapLines: true,
  visibleContent: ["timestamp", "jobName", "supervisor", "agent", "actions"]
};

export const ALL_SUPERVISORS_OPTION = "__ALL__";

